<template>
    <v-container>
        <v-dialog v-model="isVisible" persistent max-width="290">
            <v-card>
                <v-card-title class="text-h5">
                    Add New Holder
                </v-card-title>
                <v-card-text>Do you want to add a new Holder?</v-card-text>
                <v-card-text>
                        <v-form ref="formNewBuilding" lazy-validation>
                            <v-text-field label="Code" v-model="newHolder.code" prepend-icon="edit" :rules="[v=>!!v || 'Holder Code is required']"></v-text-field>
                            <v-text-field label="Description" v-model="newHolder.description" prepend-icon="edit" :rules="[v=>!!v || 'Holder Description is required']"></v-text-field>
                            <v-card-actions>
                                <v-spacer>
                                <v-btn color="green darken-1" text @click="closeDialog">Cancel</v-btn>
                                <v-btn color="green darken-1" text @click="onSave">Save</v-btn>
                                </v-spacer>
                            </v-card-actions>
                        </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import radiationAPI from '@/services/radiationservice'

export default {
 name:'HolderPanel',
 props: {
     isVisible:{
         type: Boolean,
         require: true
     },
     newHolder:{
         type:Object,
         required: true,
         default:()=>{return undefined}
     }
    },
    data:function(){
        return {
            dialogWidth:'45%',
        }
    } ,
    methods:{
        closeDialog:function(){
            this.$emit('close:isVisible',false);
        },
        onSave: async function(){
            await radiationAPI.addHolder(this.newHolder)
            .then(response=>{
                console.log(response);
                this.$emit('add:newHolder',this.newHolder);
            })
            .catch(error=>{console.log(error)});
        }
    } 
 }
</script>
